<ft-modal-editor-wrapper>
    <ng-template #triggerTmpl>
        <ng-content />
    </ng-template>
    <div class="ft2-form-group flex f-md-wrap">
        <div class="flex full-width datepickers">
            <input class="ft2-input -large -square -no-border"
                   [ngModel]="value"
                   (ngModelChange)="onModelChange($event)"
                   [placeholder]="placeholder"
                   [required]="required"
                   #inputElement
                   #control="ngModel"
                   readonly
                   datepickerClass="ft-daterange-picker-calendar"
                   ngbDatepicker
                   (click)="dpStart.open()"
                   #dpStart="ngbDatepicker"
                   [dayTemplate]="t"
                   [navigation]="'arrows'">
        </div>
    </div>
</ft-modal-editor-wrapper>
<ng-template #t let-date let-focused="focused" let-disabled="disabled">
          <span class="custom-day"
                [class.disabled]="disabled"
                [class.focused]="focused">
            {{ date.day }}
          </span>
</ng-template>
